import { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {
  ImagesContainer,
  ImagesDesktopWrapper,
  ImagesMobileSlider,
  StaggeredImage1,
  StaggeredImage2,
  StaggeredImage3,
  StaggeredImage4,
  SliderImage,
} from './CoreBancarioImagesContainer.styles';
import HeaderImage1 from '../../assets/images/CoreBankingModulesImages/headerImage/image1.webp';
import HeaderImage2 from '../../assets/images/CoreBankingModulesImages/headerImage/image2.webp';
import HeaderImage3 from '../../assets/images/CoreBankingModulesImages/headerImage/image3.webp';
import HeaderImage4 from '../../assets/images/CoreBankingModulesImages/headerImage/image4.webp';

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 2.2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  centerMode: false,
  variableWidth: false,
};

export const CoreBancarioImagesContainer = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  const images = [
    { src: HeaderImage1, alt: 'Core Bancario Dynamicore', offset: 'down' },
    { src: HeaderImage2, alt: 'Plataforma modular bancaria', offset: 'up' },
    { src: HeaderImage3, alt: 'Tecnología bancaria digital', offset: 'down' },
    { src: HeaderImage4, alt: 'Soluciones Core Bancario', offset: 'up' },
  ];

  return (
    <ImagesContainer>
      {!isMobile ? (
        <ImagesDesktopWrapper>
          <StaggeredImage1 src={HeaderImage1} alt="Core Bancario Dynamicore" />
          <StaggeredImage2 src={HeaderImage2} alt="Plataforma modular bancaria" />
          <StaggeredImage3 src={HeaderImage3} alt="Tecnología bancaria digital" />
          <StaggeredImage4 src={HeaderImage4} alt="Soluciones Core Bancario" />
        </ImagesDesktopWrapper>
      ) : (
        <ImagesMobileSlider>
          <Slider {...sliderSettings}>
            {images.map((image, index) => (
              <div key={index}>
                <SliderImage 
                  src={image.src} 
                  alt={image.alt}
                  offset={image.offset}
                />
              </div>
            ))}
          </Slider>
        </ImagesMobileSlider>
      )}
    </ImagesContainer>
  );
};
